import { Config } from '@leverege/plugin';
import { GlobalState, UI, UserSettings } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { History } from '@leverege/molten-core';
const {
  tf
} = I18N.ns('molten.screens.account.Personas');
export default {
  id: 'account.mobile.Personas',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  layout: {
    sort: '_1'
  },
  handles: context => {
    return GlobalState.get().ui?.personas?.length > 1 && context.mobile;
  },
  getActions(context) {
    const {
      personas,
      activePersona
    } = GlobalState.get().ui;
    const actions = personas.map(persona => ({
      handles: () => GlobalState.get().ui?.personas?.length > 1 && context.mobile,
      appearance: () => ({
        name: persona.displayName || persona.name,
        checked: persona === activePersona,
        checkStyle: 'radio'
      }),
      perform: () => {
        GlobalState.dispatch(UI.multiSet({
          activePersona: persona
        }));
        GlobalState.dispatch(History.push('/'));
        UserSettings.delegate.setProfile(persona.name);
        UserSettings.preloadAll();
      }
    }));
    return [{
      type: 'layoutNode',
      name: tf('name'),
      icon: Config.get('Main', 'userRoleIcon', 'https://molten-ui-assets.storage.googleapis.com/user-role.svg'),
      items: actions,
      layout: {
        sectionName: null
      }
    }];
  }
};